<template>
    <div class="coupon-box coupon-ad-box" @click="goCouponUseDetail">
        <img src="@/assets/images/coupon/ad_coupon_2@2x.png" v-if="openSider">
        <img src="@/assets/images/coupon/ad_coupon_4@2x.png" v-else-if="type == 'couponList'">
        <img src="@/assets/images/coupon/ad_coupon_3@2x.png" v-else-if="type == 'setup'">
        <img src="@/assets/images/coupon/ad_coupon_1@2x.png" v-else> 
      <!-- <div class="coupon-ad-btn-b">
        <van-button class="coupon-btn" type="primary">去领取</van-button>
      </div>  -->
    </div>
</template>
<script>
import { clickUrl } from '@/utils'

export default {
  name: "CouponGroup",
  props:{
      openSider: {
          type: Boolean,
          default: false
      },
      type:{
          type: String,
          default: ''
      }
  },
  data(){
    return{
    }
  },
  mounted(){
      
  },
  methods:{
    goCouponUseDetail(){
       // clickUrl('/coupon/use_detail')
    }
  }
}
</script>
<style lang="scss" scoped>
  .coupon-box {
    width: 100%;
    margin: 0 auto;
    text-align: center;
    position: relative;
  
    img {
      width: 100%;
      height: 100%;
      background-size: contain;
    }
  }

  .coupon-ad-box {
    width: auto;
    min-height: 0.38rem;
    margin-bottom: 0.67rem;
  
    .coupon-ad-btn-b {
      width: 2.7rem;
      height: 0.96rem;
      position: absolute;
      top: 55%;
      right: 6%;
      text-align: center;
      z-index: 1;
    }
  
    .coupon-btn {
      width: 100%;
      height: 0.96rem !important;
      line-height: 0.96rem;
      background: linear-gradient(180deg, #F8E9CE 0%, #F1CE99 100%);
      box-shadow: 0px 4px 4px 1px rgba(0, 0, 0, 0.25);
      border-radius: 26px;
      border: 0;
      font-size: 14px;
      font-weight: 600;
      color: #FF5019;
    }
  }
</style>
